var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarVerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 38,
    viewBox: "0 0 52 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11925_39264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 18.9997C45 29.2993 36.5016 37.6635 26 37.6635C15.4984 37.6635 7 29.2993 7 18.9997C7 8.70016 15.4984 0.335938 26 0.335938C36.5016 0.335938 45 8.70016 45 18.9997Z",
    fill: "#4ABFA1",
    fillOpacity: 0.06,
    stroke: "#4ABFA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 6.93359L29.7943 14.4089L38.2782 15.615L32.1393 21.4305L33.5881 29.6462L26.0004 25.7653L18.4128 29.6462L19.8615 21.4305L13.7227 15.615L22.2066 14.4089L26.0004 6.93359Z",
    stroke: "#4ABFA1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11925_39264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarVerde);
export default __webpack_public_path__ + "static/media/star_verde.ffabdc53.svg";
export { ForwardRef as ReactComponent };